/**
 * One thing the site's search finds: a page, a guide, a line of the card, a route of the contract, an event of
 * the catalog, a field of vestra.yaml, an error code, a method of the TypeScript or Python SDK, or a command of
 * the CLI (T13c).
 */
export interface SearchItem {
  kind:
    | "page"
    | "guide"
    | "line"
    | "route"
    | "event"
    | "field"
    | "error"
    | "typescript"
    | "python"
    | "cli";
  title: string;
  detail: string;
  href: string;
}

/** What the search box matches an item by: its kind and its name. Its detail rides along as keywords. */
export function searchValue(item: SearchItem): string {
  return `${item.kind} ${item.title}`;
}

/**
 * How well an item answers a search (the box's filter): 1 when its name holds the search, 0.75 when its name
 * holds every word, 0.25 when its name and detail together do, and 0 otherwise. cmdk's own filter is fuzzy, so
 * "trace" would match memory's "remembers about each user: explore" letter by letter; this one never does.
 */
export function searchScore(
  value: string,
  search: string,
  keywords: readonly string[] = []
): number {
  const query = search.trim().toLowerCase();
  if (!query) return 1;
  const name = value.toLowerCase();
  if (name.includes(query)) return 1;
  const words = query.split(/\s+/);
  if (words.every((w) => name.includes(w))) return 0.75;
  const all = `${name} ${keywords.join(" ").toLowerCase()}`;
  return words.every((w) => all.includes(w)) ? 0.25 : 0;
}
